export type UnderlineProps = {
  className?: string;
};

export const Underline = (props: UnderlineProps) => {
  const { className } = props;

  return (
    <span
      aria-hidden="true"
      style={{ display: "block", width: 137, height: 10 }}
    >
      <svg
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 137 10"
      >
        <title>Underline icon</title>
        <path
          d="M0 7.133c-.01-.758 1.643-1.961 2.66-1.987 1.018-.027 2.98.076 5.89.048 2.906-.024 20.056-.519 25.942-.774 5.885-.255 40.171-1.85 48.603-2.167 8.426-.32 30.733-1.147 35.092-1.26 4.359-.113 13.008-.337 13.734-.458.726-.121 2.385-.97 3.703-.246s1.86 2.83.859 3.965c-1.002 1.135-2.52 1.53-3.689 1.256s-2.769-.434-4.583-.486c-1.82-.055-40.255 1.244-44.18 1.448-3.925.2-34.801 1.36-39.454 1.579-4.647.219-11.474.648-21.5 1.16-10.022.513-16.636.735-18.528.784-1.892.05-3.13-.27-3.796-1.113C.087 8.039.01 7.839 0 7.132Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};
